import http from '@core/fetch'

const get = url => query => http(url, { body: query })
const post = url => params => http.post(url, { body: params })

export default {
  // 获取酒店商家vr数据
  getHotelVrInfo: get(
    '/p/wedding/index.php/admin/APIHotelMerchant/hotelVrInfo'
  ),
  // 获取酒店商家全景列表
  getPanoList: get('/p/wedding/index.php/Admin/APIHotelMerchant/panoList'),
  // 获取酒店全景数据
  getPano: get('/p/wedding/index.php/Admin/APIHotelMerchant/pano'),
  // 上传全景图
  postPanoAdd: post('/p/wedding/index.php/Admin/APIHotelMerchant/panoAdd'),
  // 删除全景
  postPanoDelete: post(
    '/p/wedding/index.php/Admin/APIHotelMerchant/panoDelete'
  ),
  // 编辑全景数据
  postPanoEdit: post('/p/wedding/index.php/Admin/APIHotelMerchant/panoEdit'),
  // 获取vr信息
  getPanoDetail: get('/p/wedding/index.php/Home/APIPano/detail'),
  // 设置视角
  postPanoStartupView: post(
    '/p/wedding/index.php/Admin/APIHotelMerchant/panoStartupView'
  ),
  // 设置热点
  postPanoHotdata: post(
    '/p/wedding/index.php/Admin/APIHotelMerchant/panoHotdata'
  ),
  // 获取酒店vr权限
  getMerchantPrivilege: get(
    '/p/wedding/index.php/Admin/APIMerchantServicePrivilege/MerchantPrivilege'
  )
}
